import { schema } from 'normalizr';

export const statisticSchema = new schema.Entity('statistics');
export const statisticListSchema = [ statisticSchema ];



// WEBPACK FOOTER //
// ./src/schemas/statistic.js